import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Module } from 'src/app/interfaces/module.interface';

@Component({
    selector: 'app-slider-module',
    templateUrl: './slider-module.component.html',
    styleUrls: ['./slider-module.component.scss']
})
export class SliderModuleComponent implements OnInit {
    @Input() module: Module;
    @Input() i: number;
    @Input() postColor;
    @Input() logo: any;
    width: number = 50;
    mymodel: number = 50;
    screenWidth: number;
    innerWidth: number;
    loadedafter: boolean = false;
    loadedBefore: boolean = false;
    inViewPort: boolean = false;
    postLoaded: boolean = false;
    isChecked: boolean = false;
    preloader_color;
    viewPortActive: boolean = false;

    constructor() { }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.screenWidth = window.innerWidth;
    }

    ngOnInit() {
        this.screenWidth = window.innerWidth;
        this.innerWidth = window.innerWidth;
        this.preloader_color = this.getRandomColor();
    }

    isLoadedBefore() {
        this.loadedBefore = true;
        this.isLoaded();
    }

    isLoadedAfter() {
        this.loadedafter = true;
        this.isLoaded();
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.viewPortActive = true;
            this.inViewPort = true;
            this.isLoaded();
        }
    }

    isLoaded() {
        if (this.loadedBefore == true && this.loadedafter == true && this.inViewPort == true) {
            this.postLoaded = true;
            if (!this.isChecked) {
                this.initComparisons();
            }
        }
    }

    initComparisons() {
        this.isChecked = true;
        var x, i;
        x = document.getElementsByClassName("img-comp-overlay-" + this.i);
        for (i = 0; i < x.length; i++) {
            if (i == x.length - 1) {
                compareImages(x[i]);
            }
        }
        function compareImages(img) {
            var slider, img, clicked = 0, w, h;
            w = img.offsetWidth;
            h = img.offsetHeight;

            slider = document.createElement("DIV");
            slider.setAttribute("class", "img-comp-slider");
            img.parentElement.insertBefore(slider, img);
            slider.style.top = ((h / 2) - (slider.offsetHeight / 2) - 20) + "px";
            slider.style.position = 'absolute';
            slider.style.zIndex = '9';
            slider.style.cursor = 'pointer';
            slider.style.width = '40px';
            slider.style.height = '40px';
            slider.style.border = '3px solid white';
            slider.style.backgroundSize = '40px';
            slider.style.backgroundRepeat = 'no-repeat';
            slider.style.backgroundPosition = '50%';
            slider.innerHTML = "<div style='background:white; width:3px; height:20px; position:absolute; top:50%; left:50%; transform:translate(-50%, -50%)'></div>";
            slider.style.left = '20px';
            img.style.width = "0px";
            slider.style.transition = 'left cubic-bezier(0.3, 0.3, 0.3, 1) .5s';
            setTimeout(() => {
                img.style.transition = 'width cubic-bezier(0.3, 0.3, 0.3, 1) .5s';
                slider.style.left = (w / 2) - 20 + "px";
                img.style.width = (w / 2) + "px";
            }, 100);
            setTimeout(() => {
                slider.style.transition = '';
                img.style.transition = '';
            }, 600);

            slider.addEventListener("mousedown", slideReady);
            window.addEventListener("mouseup", slideFinish);
            slider.addEventListener("touchstart", slideReady);
            window.addEventListener("touchstop", slideFinish);
            window.addEventListener("touchend", slideFinish);

            function slideReady(e) {
                if (e.cancelable) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                e.preventDefault();
                clicked = 1;
                window.addEventListener("mousemove", slideMove);
                window.addEventListener("touchmove", slideMove);
                window.addEventListener("touchend", slideMove);
            }
            function slideFinish() {
                clicked = 0;
            }
            function slideMove(e) {
                var pos;
                if (clicked == 0) return false;
                pos = getCursorPos(e)
                if (pos < 0) pos = 0;
                if (pos > w) pos = w;
                slide(pos);
            }
            function getCursorPos(e) {
                var a, x = 0;
                e = e || window.event;
                a = img.getBoundingClientRect();
                if (e.pageX) {
                    x = e.pageX - a.left;
                } else {
                    x = e.touches[0].pageX - a.left;
                }
                x = x - window.pageXOffset;
                return x;
            }
            function slide(x) {
                img.style.width = x + "px";
                slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
            }
        }
    }

    getRandomColor() {
        const hue = 0;
        const saturation = 0;
        const brightness = this.getRandomNumber(85, 95);
        return 'hsl(' + hue + ', ' + saturation + '%, ' + brightness + '%)';
    }

    getRandomNumber(low, high) {
        var r = Math.floor(Math.random() * (high - low + 1)) + low;
        return r;
    }
}
